import React from 'react';
import AloDropdown, { DropdownItem } from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloDropdown';
import { pluralize } from 'src/scripts/utils/helpers';
import { Departments } from './index.types';

type Props = {
  departments: Departments;
  listingCount: number;
  setDepartmentFilter: (val: string) => void;
  setLocationFilter: (val: string) => void;
};

const DEPARTMENT_DEFAULT = { key: '', text: 'All Departments' };
const LOCATION_DEFAULT = { key: '', text: 'All Locations' };

export const DepartmentFilters = ({ departments, listingCount, setDepartmentFilter, setLocationFilter }: Props) => {
  const allJobs = Object.values(departments).flat();
  const locationNames = [...new Set(allJobs.map(({ location }) => location.name))];
  const departmentNames = Object.keys(departments);
  return (
    <div className="career-filters">
      <div className="career-filters__count">
        <p className="body">{pluralize(listingCount, 'Listing')}</p>
      </div>
      <div className="career-filters__dropdowns">
        {departmentNames.length > 1 && (
          <AloDropdown
            dropdownItems={[DEPARTMENT_DEFAULT, ...departmentNames.map((text) => ({ text, key: text }))]}
            onChange={({ key }: DropdownItem) => setDepartmentFilter(key)}
            placeholder="Filter By Department"
          />
        )}
        {locationNames.length > 1 && (
          <AloDropdown
            dropdownItems={[LOCATION_DEFAULT, ...locationNames.map((text) => ({ text, key: text }))]}
            onChange={({ key }: DropdownItem) => setLocationFilter(key)}
            placeholder="Filter By Location"
          />
        )}
      </div>
    </div>
  );
};
